export enum company {
  loadDropdowns = "api/Company/loadDropdown",
  loadGrid = "api/Company/getAllCompany",
  getCompanyById = "api/Company/getCompanyByid?Id",
  saveCompany = "api/Company/addCompany",
  updateCompany = "api/Company/updateCompany",
}

export enum user {
  loadDropdowns = "api/User/loadDropdowns",
  loadUserLayerRefDropdowns = "api/User/loadUserLayerRefDropdowns",
  loadGrid = "api/User/loadUsers",
  getUserById = "api/User/getUserById",
  addUser = "api/User/addUser",
  updateUser = "api/User/updateUser",
  savePassword = "api/User/savePassword",
  confirmOldPassword = "api/User/confirmOldPassword",
  confirmOtp = "api/User/confirmOtp",
  getOtp = "api/User/getOtp",
}

export enum contractorGetter {
  loadCompanyDropdown = "api/Contractor/loadCompanyDropdown",
  loadExtUnionDropdown = "api/Contractor/loadExtUnionDropdown",
  loadFormDropdowns = "api/Contractor/loadFormDropdowns",
  loadContractorGrid = "api/Contractor/getAllContractors",
  getContractorById = "api/Contractor/getContractorById",
  addContractor = "api/Contractor/addContractor",
  updateContractor = "api/Contractor/updateContractor",
}

export enum storage {
  companyDropDown = "api/Storage/getCompanyDropdowns",
  loadDropdown = "api/Storage/loadDropdowns",
  loadStorageGrid = "api/Storage/getAllStorages",
  getStorageById = "api/Storage/getStorageById",
  addStorage = "api/Storage/addStorage",
  updateStorage = "api/Storage/updateStorage",
}
export enum externalUnion {
  loadDropdown = "api/ExternalUnion/loadDropdowns",
  loadCompanyDropdown = "api/ExternalUnion/loadCompanyDropdown",
  loadUnion = "api/ExternalUnion/loadUnion",
  getUnionByid = "api/ExternalUnion/getUnionByid",
  addUnion = "api/ExternalUnion/addUnion",
  updateUnion = "api/ExternalUnion/updateUnion",
}
export enum plant {
  loadDropdown = "api/Plant/getAllDropdowns",
  loadExtDropdown = "api/Plant/getExtUnionDropdowns",
  loadGridData = "api/Plant/getAllPlants",
  addPlant = "api/Plant/addPlant",
  updatePlant = "api/Plant/updatePlant",
  getPlantById = "api/Plant/getPlantById",
}

export enum loadDropdown {
  countryDropdown = "api/Dropdown/countryDropdown",
  stateDropdown = "api/Dropdown/stateDropdown",
  companyDropdown = "api/Dropdown/companyDropdown",
  extUnionDropdown = "api/Dropdown/extUnionDropdown",
}
export enum section {
  loadComapnyDropdown = "api/Section/loadDropdown",
  loadDropDowns = "api/Section/loadExtDropdown",
  addData = "api/Section/addData",
  updateData = "api/Section/updateData",
  loadSectionGrid = "api/Section/loadSectionGrid",
  loadSectionGridById = "api/Section/loadSectionGridById",
}
export enum userAuth {
  savePassword = "api/UserAuth/savePassword",
  authUser = "api/UserAuth/authUser",
  confirmOtp = "api/UserAuth/confirmOtp",
  getOtp = "api/UserAuth/getOtp",
  checkUser = "api/UserAuth/checkUser",
}

export enum userRights {
  loadDropdowns = "api/UserRights/loadDropdowns",
  loadGrid = "api/UserRights/loadUsers",
  loadMenuNavigation = "api/UserRights/loadMenuNavigation",
  loadRootLevelMenu = "api/UserRights/loadRootLevelMenu",
  loadUserRights = "api/UserRights/loadUserRights",
  assignUserRights = "api/UserRights/assignUserRights",
}

export enum route {
  loadGrid = "api/Route/getAllRoute",
  loadDropdowns = "api/Route/loadDropdowns",
  loadCompany = "api/Route/loadCompanyDropdown",
  getRouteById = "api/Route/getRouteById",
  saveRoute = "api/Route/addRoute",
  updateRoute = "api/Route/updateRoute",
}

export enum vehicleMaster {
  loadVehicleData = "api/Vehicle/loadGridData",
  loadDropdown = "api/Vehicle/loadDropdown",
  loadContractorDropdown = "api/Vehicle/LoadContractorDropdown",
  addVehicle = "api/Vehicle/addVehicle",
  updateVehicle = "api/Vehicle/updateVehicle",
  getVehicleById = "api/Vehicle/getVehicleById",
}

export enum transportCost {
  getCompanyDropDown = "api/TransportCost/loadCompanyDropdown",
  loadRouteDropdown = "api/TransportCost/loadRouteDropdown",
  loadTransportRate = "api/TransportCost/loadTransportRate",
  getTransportRateById = "api/TransportCost/getTransportRateById",
  addTransportRate = "api/TransportCost/addTransportRate",
  updateTransportRate = "api/TransportCost/updateTransportRate",
  loadRoute = "api/TransportCost/loadRoute",
  addRoute = "api/TransportCost/addRoute",
  deleteRoute = "api/TransportCost/deleteRoute",
}

export enum itemGroup {
  loadCompanyDropdown = "api/ItemGroup/loadCompanyDropdown",
  loadExtUnionDropdown = "api/ItemGroup/loadExtUnionDropdown",
  loadItemGroup = "api/ItemGroup/loadItemGroup",
  getItemGroupById = "api/ItemGroup/getItemGroupById",
  addItemGroup = "api/ItemGroup/addItemGroup",
  updateItemGroup = "api/ItemGroup/updateItemGroup",
}

export enum Unit {
  loadUnitDropdown = "api/Unit/loadUnitDropdown",
  loadCompanyDropdown = "api/Unit/loadCompanyDropdown",
  loadUnit = "api/Unit/loadUnit",
  getUnitById = "api/Unit/getUnitById",
  addUnit = "api/Unit/addUnit",
  updateUnit = "api/Unit/updateUnit",
}

export enum Item {
  loadCompanyDropdown = "api/Item/loadCompanyDropdown",
  loadGridDropdown = "api/Item/loadGridDropdown",
  onCompanyChangeDropdown = "api/Item/onCompanyChangeDropdown",
  loadUnitDropdownForMapping = "api/Item/loadUnitDropdownForMapping",
  loadItem = "api/Item/loadItem",
  getItemById = "api/Item/getItemById",
  addItemWithStockAndUnit = "api/Item/addItemWithStockAndUnit",
  updateItemWithStockAndUnit = "api/Item/updateItemWithStockAndUnit",
}

export enum labTestingParameter {
  loadDropdowns = "api/LabTesting/loadDropdowns",
  loadGrid = "api/LabTesting/loadGrid",
  getParameterById = "api/LabTesting/getParameterById",
  addParameter = "api/LabTesting/addParameter",
  updateParameter = "api/LabTesting/updateParameter",
}

export enum ProductAnalysis {
  loadCompanyDropdown = "api/ProductAnalysis/loadCompanyDropdown",
  loadDropdowns = "api/ProductAnalysis/loadDropdowns",
  loadPrameterValues = "api/ProductAnalysis/loadPrameterValues",
  loadGrid = "api/ProductAnalysis/loadGrid",
  getProductAnalysisByItemId = "api/ProductAnalysis/getProductAnalysisByItemId",
  assignProductParamMappings = "api/ProductAnalysis/assignProductParamMappings",
}

export enum DayOpenCloseGetter {
  loadDays = "api/Day/loadDays",
  saveDays = "api/Day/saveDays",
}

export enum fgBom {
  loadCompanyDropDown = "api/FgBom/LoadCompanyDropDown",
  loadDropDowns = "api/FgBom/LoadDropDowns",
  loadFgBomGrid = "api/FgBom/LoadFgBomGrid",
  getFgBomById = "api/FgBom/GetFgBomById",
  loadItemList = "api/FgBom/LoadItemList",
  loadMaterialsList = "api/FgBom/LoadMaterialsList",
  saveFgBom = "api/FgBom/SaveFgBom",
  updateFgBom = "api/FgBom/UpdateFgBom",
}

export enum sfgBom {
  loadCompanyDropDown = "api/SfgBom/LoadCompanyDropDown",
  loadDropDowns = "api/SfgBom/LoadDropDowns",
  loadSfgBomGrid = "api/SfgBom/LoadSfgBomGrid",
  getSfgBomById = "api/SfgBom/GetSfgBomById",
  loadItemList = "api/SfgBom/LoadItemList",
  saveSfgBom = "api/SfgBom/SaveSfgBom",
  updateSfgBom = "api/SfgBom/UpdateSfgBom",
  calculateKgs = "api/Helper/calculateQtyInKgUnit",
}

export enum fgProductionGetter {
  loadCompanyDropdown = "api/FgTransaction/loadCompanyDropdown",
  onCompanyChangeDropdown = "api/FgTransaction/onCompanyChangeDropdown",
  loadGrid = "api/FgTransaction/loadGrid",
  calculateQty = "api/FgTransaction/calculateQty",
  loadMaterialsForNew = "api/FgTransaction/loadMaterialsForNew",
  loadProductById = "api/FgTransaction/loadProductById",
  loadFgBomDropdown = "api/FgTransaction/loadFgBomDropdown",
  saveFgProd = "api/FgTransaction/saveFgProd",
  updateFgProd = "api/FgTransaction/updateFgProd",
  deleteFgProd = "api/FgTransaction/deleteFgProd",
  LoadItemListByType = "api/Helper/loadItemListByType",
  findAvailableQty = "api/FgTransaction/findAvailableQty",
}

//transaction
export enum sfgProductionApi {
  loadCompanyDropDown = "api/SfgProd/LoadCompanyDropDown",
  loadDropDowns = "api/SfgProd/LoadDropDowns",
  loadItemListDD = "api/SfgProd/LoadItemListDD",
  LoadItemListByType = "api/SfgProd/LoadItemListByType",
  LoadUnitDD = "api/SfgProd/LoadUnitDD",
  loadItemListArray = "api/SfgProd/LoadItemListArray",
  loadSfgBomGridByDate = "api/SfgProd/LoadSfgBomGridByDate",
  getSfgBomById = "api/SfgProd/GetSfgBomById",
  saveSfgBom = "api/SfgProd/SaveSfgBom",
  updateSfgBom = "api/SfgProd/UpdateSfgBom",
  deleteSfgProd = "api/SfgProd/deleteSfgProd",
  OnProdQtyChange = "api/SfgProd/OnProdQtyChange",
  FindAvailbleQty = "api/SfgProd/FindAvailbleQty",
  calculateKgs = "api/Helper/calculateQtyInKgUnit",
}

export enum ProductMovementGetter {
  loadCompanyDropdown = "api/ProductMovement/loadCompanyDropdown",
  onCompanyChangeDropdown = "api/ProductMovement/onCompanyChangeDropdown",
  loadGrid = "api/ProductMovement/loadGrid",
  getProdMovementById = "api/ProductMovement/getProdMovementById",
  loadItemDropdowns = "api/ProductMovement/loadItemDropdowns",
  loadUnitDropdowns = "api/ProductMovement/loadUnitDropdowns",
  addProdMovement = "api/ProductMovement/addProdMovement",
  updateProdMovement = "api/ProductMovement/updateProdMovement",
  deleteProdMovement = "api/ProductMovement/deleteProdMovement",
  calculateKgFatKgSnf = "api/ProductMovement/calculateKgFatKgSnf",
  allDropdownsOfCompany = "api/ProductMovement/AllDropdownsOfCompany",
}

export enum storeRequisition {
  loadDropDowns = "api/StoreRequisition/LoadDropDowns",
  loadItemList = "api/StoreRequisition/LoadItemList",
  loadUnitlist = "api/StoreRequisition/LoadUnitList",
  loadSRGridByDateRange = "api/StoreRequisition/LoadSRGridByDateRange",
  addSRSlip = "api/StoreRequisition/AddSRSlip",
  updateSRSlip = "api/StoreRequisition/UpdateSRSlip",
  GetSRById = "api/StoreRequisition/GetSRById",
  DeleteSR = "api/StoreRequisition/DeleteSR",
}

export enum ProductSale {
  loadMasterDropdowns = "api/ProductSale/loadMasterDropdowns",
  loadItemDropdown = "api/ProductSale/loadItemDropdown",
  loadItemUnitMappingDropdown = "api/ProductSale/loadItemUnitMappingDropdown",
  loadProductSaleGrid = "api/ProductSale/loadProductSaleGrid",
  addProductSale = "api/ProductSale/addProductSale",
  getProductSaleById = "api/ProductSale/getProductSaleById",
  deleteProductSale = "api/ProductSale/deleteProductSale",
  updateProductSale = "api/ProductSale/updateProductSale",
  validateExcelImport = "api/ProductSale/validateExcelImport",
}

export enum closingStock {
  loadDropDowns = "api/ClosingStock/LoadDropDowns",
  loadItemList = "api/ClosingStock/LoadItemList",
  loadUnitlist = "api/ClosingStock/LoadUnitList",
  loadGridByDateRange = "api/ClosingStock/LoadGridByDateRange",
  addClosingStock = "api/ClosingStock/AddClosingStock",
  updateClosingStock = "api/ClosingStock/UpdateClosingStock",
  getById = "api/ClosingStock/GetById",
  deleteClosingStock = "api/ClosingStock/DeleteClosingStock",
  loadShiftList = "api/ClosingStock/LoadShiftList",
}
export enum milkProcTransaction {
  loadDropDowns = "api/MilkProc/LoadDropDowns",
  loadGridByDateRange = "api/MilkProc/LoadGridByDate",
  loadShiftList = "api/MilkProc/LoadShiftList",
  loadItemIds = "api/MilkProc/LoadItemIds",
  GetById = "api/MilkProc/GetById",
  addMilkProc = "api/MilkProc/AddMilkProc",
  updateMilkProc = "api/MilkProc/UpdateMilkProc",
  DeleteMilkProc = "api/MilkProc/DeleteMilkProc",
}

export enum TankerReceive {
  loadMasterDropdowns = "api/TankerReceive/loadGridDropdowns",
  loadRouteDropdown = "api/TankerReceive/loadRouteDropdown",
  loadGeneralDropdowns = "api/TankerReceive/loadGeneralDropdowns",
  loadReceiveDropdowns = "api/TankerReceive/loadReceiveDropdowns",
  loadItemUnitMappingDropdown = "api/TankerReceive/loadItemUnitMappingDropdown",
  addTankerReceive = "api/TankerReceive/createTankerReceive",
  getTankerReceiveById = "api/TankerReceive/getTankerReceiveById",
  getTankerReceiveByIdWithDropdowns = "api/TankerReceive/getTankerReceiveByIdWithDropdowns",
  deleteTankerReceive = "api/TankerReceive/deleteTankerReceive",
  updateTankerReceive = "api/TankerReceive/updateTankerReceive",
  unloadReceivedTanker = "api/TankerReceive/unloadReceivedTanker",
  loadTankerReceiveGrid = "api/TankerReceive/loadTankerReceiveGrid",
  loadCleaningStatus = "api/TankerReceive/loadCleaningStatus",
  saveCleaningStatus = "api/TankerReceive/saveCleaningStatus",
}
export enum TankerDispatch {
  loadMasterDropdowns = "api/TankerDispatch/loadMasterDropdowns",
  loadRouteDropdown = "api/TankerDispatch/loadRouteDropdown",
  loadLabsDropdowns = "api/TankerDispatch/loadLabsDropdowns",
  loadItemUnitMappingDropdown = "api/TankerDispatch/loadItemUnitMappingDropdown",
  loadTankerDispatchGrid = "api/TankerDispatch/loadTankerDispatchGrid",
  addTankerDispatch = "api/TankerDispatch/addTankerDispatch",
  getTankerDispatchById = "api/TankerDispatch/getTankerDispatchById",
  deleteTankerDispatch = "api/TankerDispatch/deleteTankerDispatch",
  updateTankerDispatch = "api/TankerDispatch/updateTankerDispatch",
}

export enum TankerDispatchTesting {
  loadTdTestingGrid = "api/TdTesting/loadTdTestingGrid",
  acknowledgeTd = "api/TdTesting/acknowledgeTd",
  getTestingParameters = "api/TdTesting/getTestingParameters",
  getTestingResults = "api/TdTesting/getTestingResults",
  getReceiveTestingResults = "api/TdTesting/getReceiveTestingResults",
  addTdTesting = "api/TdTesting/addTdTesting",
  modifyTdTesting = "api/TdTesting/modifyTdTesting",
}

export enum sampleIntimation {
  loadDropDowns = "api/SampleIntimation/LoadDropDown",
  loadLabList = "api/SampleIntimation/LoadLabList",
  loadProductList = "api/SampleIntimation/LoadProductList",
  loadGrid = "api/SampleIntimation/LoadGrid",
  saveSample = "api/SampleIntimation/SaveSample",
  getById = "api/SampleIntimation/GetById",
  updateSample = "api/SampleIntimation/UpdateSample",
  deleteSample = "api/SampleIntimation/DeleteSample",
}

export enum productTesting {
  loadLabList = "api/ProductTesting/LoadLabList",
  loadGrid = "api/ProductTesting/LoadGrid",
  Acknowledgement = "api/ProductTesting/Acknowledgement",
}

export enum labResult {
  getParameters = "api/LabResult/getParameters",
  addParamResult = "api/LabResult/AddParamResult",
  getResult = "api/LabResult/GetResult",
  updateParamResult = "api/LabResult/UpdateParamResult",
}

export enum TankerReceiveTesting {
  loadTankerReceiveTestingGrid = "api/TrTestingResult/loadTankerReceiveTestingGrid",
  acknowledgeReceivedSample = "api/TrTestingResult/acknowledgeReceivedSample",
  getLabParams = "api/TrTestingResult/getLabParams",
  generateTrTestingResults = "api/TrTestingResult/generateTrTestingResults",
  getTrTestingResults = "api/TrTestingResult/getTrTestingResults",
  generateTdTestingResults = "api/TrTestingResult/generateTdTestingResults",
  getTdTestingResults = "api/TrTestingResult/getTdTestingResults",
}

export enum itemMasterGroup {
  loadCompanyDropdown = "api/ItemMasterGroup/loadCompanyDropdown",
  loadItemMasterGroup = "api/ItemMasterGroup/loadItemMasterGroup",
  saveItemMasterGroups = "api/ItemMasterGroup/saveItemMasterGroups",
}

export enum dashboard {
  LoadDashboardData = "api/Dashboard/loadDashboardData",
}
export enum plantLossGainReport {
  loadMasterDropdowns = "api/PlantLossGainReport/loadMasterDropdowns",
  generateReport = "api/PlantLossGainReport/generateReport",
}
export enum sectionLossGainReport {
  loadMasterDropdowns = "api/SectionLossGainReport/loadMasterDropdowns",
  generateReport = "api/SectionLossGainReport/generateReport",
}
export enum fgProductionReport {
  loadMasterDropdowns = "api/FgProductionReport/loadMasterDropdowns",
  loadItemDropdowns = "api/FgProductionReport/loadItemDropdowns",
  generateReport = "api/FgProductionReport/generateReport",
}
export enum sfgStockReport {
  loadMasterDropdowns = "api/SfgStockReport/loadMasterDropdowns",
  loadItemDropdowns = "api/SfgStockReport/loadItemDropdowns",
  generateReport = "api/SfgStockReport/generateReport",
}
export enum TankerMovementReport {
  loadMasterDropdowns = "api/TankerMovementReport/loadMasterDropdowns",
  generateReport = "api/TankerMovementReport/generateReport",
}
export enum TankerTestingReport {
  loadMasterDropdowns = "api/TankerTestingReport/loadMasterDropdowns",
  generateReport = "api/TankerTestingReport/generateReport",
}
export enum UnitPackingReport {
  loadMasterDropdowns = "api/UnitPackingReport/loadMasterDropdowns",
  loadItemDropdowns = "api/UnitPackingReport/loadItemDropdowns",
  generateReport = "api/UnitPackingReport/generateReport",
}
export enum fgProductionSummaryReport {
  loadMasterDropdowns = "api/FgProductionSummaryReport/loadMasterDropdowns",
  generateReport = "api/FgProductionSummaryReport/generateReport",
}
export enum tankerBillingReport {
  loadMasterDropdowns = "api/TankerBillingReport/loadMasterDropdowns",
  generateReport = "api/TankerBillingReport/generateReport",
}
export enum RmPmStockReport {
  loadMasterDropdowns = "api/RmPmStockReport/loadMasterDropdowns",
  loadItemDropdowns = "api/RmPmStockReport/loadItemDropdowns",
  generateReport = "api/RmPmStockReport/generateReport",
}
export enum MilkSaleBillReport {
  loadMasterDropdowns = "api/MilkSaleBillReport/loadMasterDropdowns",
  loadContranctorDropdown = "api/MilkSaleBillReport/loadContranctorDropdown",
  generateReport = "api/MilkSaleBillReport/generateReport",
}
export enum sfgStockSummaryReport {
  loadMasterDropdowns = "api/SfgStockSummaryReport/loadMasterDropdowns",
  generateReport = "api/SfgStockSummaryReport/generateReport",
}
export enum sfgProductionReport {
  loadMasterDropdowns = "api/SfgProductionReport/loadMasterDropdowns",
  loadItemDropdowns = "api/SfgProductionReport/loadItemDropdowns",
  generateReport = "api/SfgProductionReport/generateReport",
}

export enum closingStockReport {
  loadMasterDropdowns = "api/ClosingStockReport/loadMasterDropdowns",
  generateReport = "api/ClosingStockReport/generateReport",
}
export enum MilkProcReport {
  loadMasterDropdowns = "api/MilkProcReport/loadMasterDropdowns",
  generateReport = "api/MilkProcReport/generateReport",
}
export enum TankerMovementSummaryReport {
  loadMasterDropdowns = "api/TankerMovementSummaryReport/loadMasterDropdowns",
  generateReport = "api/TankerMovementSummaryReport/generateReport",
}

export enum labAnalysis {
  loadMasterDropdowns = "api/LabAnalysisReport/loadMasterDropdowns",
  generateReport = "api/LabAnalysisReport/generateReport",
}

export enum prodRejection {
  LoadDropDowns = "api/ProductRejection/loadDropDowns",
  loadItemList = "api/ProductRejection/loadItemList",
  loadUnitList = "api/ProductRejection/loadUnitList",
  loadGrid = "api/ProductRejection/loadGrid",
  addRejection = "api/ProductRejection/addProdRejection",
  getById = "api/ProductRejection/getById",
  updateRejection = "api/ProductRejection/updateProdRejection",
  deleteRejection = "api/ProductRejection/deleteProdRejection",
  calculateKgFatKgSnf = "api/ProductRejection/calculateKgFatKgSnf",
}

export enum companyRights {
  loadGrid = "api/CompanyRights/loadGrid",
  loadRootLevelMenu = "api/CompanyRights/loadRootLevelMenu",
  loadCompanyRights = "api/CompanyRights/loadCompanyRights",
  assignCompanyRights = "api/CompanyRights/assignCompanyRights",
}

export enum companySettings {
  LoadDropDowns = "api/CompanySettings/loadDropDowns",
  getSettingsById = "api/CompanySettings/getSettingsById",
  loadShifts = "api/CompanySettings/loadShiftList",
  onSaveCompanySettings = "api/CompanySettings/onSaveCompanySettings",
  onAddShift = "api/CompanySettings/onAddShift",
  deleteShift = "api/CompanySettings/deleteShift",
}
